var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share_btn",on:{"click":function($event){return _vm.runShare('twitter')}}},[_c('button',{staticClass:"twitter"}),_c('div',[_vm._v("Twitter")])])
}
var staticRenderFns = []

export { render, staticRenderFns }